import type { ParsedSeconds, TrialSummary } from '@witmetrics/utils';
import { TRIAL_ACCESS_STATUS } from '@witmetrics/utils/constants';
import { isNullish } from '@witmetrics/utils/misc';
import { SUPPORT_LINK } from '@/constants/links';

export function isActiveTrial(
  trial: TrialSummary | null | undefined
): trial is TrialSummary {
  return trial?.status === TRIAL_ACCESS_STATUS.ACTIVE;
}

export function isExpiredTrial(
  trial: TrialSummary | null | undefined
): trial is TrialSummary {
  return trial?.status === TRIAL_ACCESS_STATUS.EXPIRED;
}

export function isNotStartedTrial(
  trial: TrialSummary | null | undefined
): trial is TrialSummary {
  return trial?.status === TRIAL_ACCESS_STATUS.NOT_STARTED;
}

export function isPendingTrial(
  trial: TrialSummary | null | undefined
): trial is TrialSummary {
  return trial?.status === TRIAL_ACCESS_STATUS.PENDING;
}

export function isRejectedTrial(
  trial: TrialSummary | null | undefined
): trial is TrialSummary {
  return trial?.status === TRIAL_ACCESS_STATUS.REJECTED;
}

export function isLockedOut(
  isAccountLocked: boolean,
  trial: TrialSummary | null | undefined
) {
  return isAccountLocked || isExpiredTrial(trial) || isNotStartedTrial(trial);
}

// PROVISIONAL: no self-serve trial-to-paid conversion exists yet (subscription "Phase 4").
export function getSubscriptionUrl() {
  return SUPPORT_LINK;
}

export function formatTrialTimeRemaining(timeRemaining?: ParsedSeconds) {
  if (isNullish(timeRemaining)) return null;
  const { days, hours, minutes } = timeRemaining;
  if (days > 0) return formatUnit(days, 'day');
  if (hours > 0) return formatUnit(hours, 'hour');
  return formatUnit(Math.max(minutes, 1), 'minute');
}

function formatUnit(count: number, unit: string) {
  return `${count} ${unit}${count === 1 ? '' : 's'}`;
}
